import { RowEventDto } from "@/dtos";
import { Events } from "@/entities";

export const formatRowEventDto = (list: Events[]): RowEventDto[] => {
    return list.map(x => {
        const row: RowEventDto = {
            ...x,
            active: x.is_active ? 'Activo' : 'Inactivo'
        }

        return row;
    });
}